import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { CustomerContactPersonModelType } from '@teinor/erp/types/company/customer/customerContactPerson'
import ModalCreateCustomerContactPerson from './ModalCreateCustomerContactPerson'
import ModalEditCustomerContactPerson from './ModalEditCustomerContactPerson'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { EditRow, DeleteRow, CustomRenderBoolean, CustomRenderStringTwoLinesTooltip } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import ModalChangeActiveCustomerContactPerson from './ModalChangeActiveCustomerContactPerson'

interface CustomerContactPersonsProps extends ComponentWithPermissions {
    basicData: CustomerModelType | null
}

const CustomerContactPersons: React.FC<CustomerContactPersonsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('contactsPerson', 'Personas de contacto'),
        newText: t('addContactPerson', 'Nueva persona de contacto'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCustomerContactPersons} CreateModalComponent={ModalCreateCustomerContactPerson} EditModalComponent={ModalEditCustomerContactPerson} pageData={pageData} DeleteModalComponent={ModalChangeActiveCustomerContactPerson} userPermissions={userPermissions} extraWhereParams={{ CustomerId: basicData?.id }} basicData={{ CustomerId: basicData?.id }} />
    )
}
interface TableCustomerContactPersonsProps extends TableComponentBaseScreenInnerProps { }

const TableCustomerContactPersons: React.FC<TableCustomerContactPersonsProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CustomerContactPersonModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            minWidth: 130,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'position',
            dataKey: 'position',
            label: t('position', 'Cargo'),
            sortable: true,
        },
        {
            id: 'mobile',
            dataKey: 'mobile',
            label: t('mobile', 'Móvil'),
        },
        {
            id: 'phone',
            dataKey: 'phone',
            label: t('phone', 'Teléfono'),
        },
        {
            id: 'email',
            dataKey: 'email',
            label: t('email', 'Email'),
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            hideColumnByDefault: true,
            customRender: (parameterValue, allRowData) => <CustomRenderStringTwoLinesTooltip id={allRowData?.rowIndex + 'notes'} value={parameterValue} />,
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disableds', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    }, label: t('active', 'Activo')
                }
            },
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} icon={!allRowData?.active ? faRotateLeft : undefined} messageTooltip={!allRowData?.active ? t('reactivate', 'Reactivar') : t('deactivate', 'Desactivar')} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='customersContactPersons' getDataFrom='/api/app/customer/customerContactPerson/getAllCustomerContactPersons'
             onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} />
    )
}

export default CustomerContactPersons